import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import Submitted from '../../../modules/withdrawal/components/coordinator/Submitted';

const SubmitPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader
        state="success"
        title={t('withdrawal->>Coordinator.Summary.Submit.ThankYouMessage')}
        largeContentContainer
      />
      <Submitted />
    </>
  );
};

export default SubmitPage;
